import { render, staticRenderFns } from "./VAttachment.vue?vue&type=template&id=3773898d&scoped=true&"
import script from "./VAttachment.vue?vue&type=script&lang=js&"
export * from "./VAttachment.vue?vue&type=script&lang=js&"
import style0 from "./VAttachment.vue?vue&type=style&index=0&id=3773898d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773898d",
  null
  
)

export default component.exports